import React, { useState } from 'react';
import Classes from './styles/style.module.css';
import Logo from '../Home/Components/Logo/Logo';

function ComplianceSecurity() {
    return (
        <>
            <div
                className={Classes.navContainer}
                style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)' }}
            >
                <div>
                    <a className={Classes.logoLink} href="/">
                        <Logo alwaysShowText={true} />
                    </a>
                </div>
                <nav className={Classes.navMenu}></nav>
                <div>
                    <a href="/">
                        <h5 className={Classes.goBackTxt}>Go back to Tawaf.ai</h5>
                    </a>
                </div>
            </div>

            <form className={Classes.hero}>
                <h1>Compliance &amp; Security Statement — Tawaf, Inc.</h1>
                <div className={Classes.form_con}>
                    <h5>Version: v1.0</h5>
                    <h5>Effective date: 2025-11-10</h5>
                    <h5>
                        Security / vulnerability reports:{' '}
                        <a href="mailto:support@tawaf.ai">support@tawaf.ai</a>
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Our baseline (MVP)</h5>
                    <ul>
                        <li>
                            <h5>
                                <strong>Encryption:</strong> TLS for data in transit; AES-256 for
                                data at rest.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Access controls:</strong> Least-privilege access, MFA for
                                admin accounts, and basic role-based permissions.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Data minimization:</strong> Location sharing is opt-in, and
                                location history is off at launch.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Secure development:</strong> Code review for releases,
                                dependency scanning, and separated environments (e.g., dev, staging,
                                production).
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Monitoring &amp; logs:</strong> Centralized logs for
                                security and reliability, with a typical retention of about 90 days.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Backups &amp; disaster recovery:</strong> Regular backups
                                and periodic restore tests.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Incident response:</strong> Defined on-call rotation and
                                breach notification steps. We will notify users and/or authorities
                                as required by law if a significant incident occurs.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Vendors:</strong> Data Processing Agreements (DPAs) with key
                                sub-processors and appropriate cross-border safeguards (for example,
                                SCCs/UK IDTA).
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>AI transparency (MVP)</h5>
                    <ul>
                        <li>
                            <h5>
                                <strong>What AI does:</strong> Speech-to-text, translation, intent
                                detection, and light personalization to improve your experience.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>What AI does not do:</strong> It does not provide medical or
                                legal diagnoses or formal professional advice.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Data handling:</strong> We do not use your data to train
                                public models without your consent. AI-related vendors are included
                                in our sub-processor/vendor list.
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>Regional notes</h5>
                    <h5>
                        We aim for a practical security and privacy baseline aligned with:
                    </h5>
                    <br />
                    <ul>
                        <li>
                            <h5>GDPR and UK GDPR</h5>
                        </li>
                        <li>
                            <h5>CPRA (California)</h5>
                        </li>
                        <li>
                            <h5>Saudi PDPL</h5>
                        </li>
                        <li>
                            <h5>UAE PDPL</h5>
                        </li>
                    </ul>
                    <br />
                    <h5>
                        Where local law requires consent (for example, certain cookies/SDKs in the
                        EEA/UK), we obtain it before processing and honor your choices.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Responsible disclosure</h5>
                    <h5>
                        If you discover a potential security issue, please email{' '}
                        <a href="mailto:support@tawaf.ai">support@tawaf.ai</a> with a description
                        and steps to reproduce. Please avoid accessing or exfiltrating data and give
                        us reasonable time to investigate and remediate.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Human summary</h5>
                    <h5>
                        We encrypt data, limit access, and keep location sharing under your control.
                        If you find a security issue, let us know so we can fix it quickly and
                        safely.
                    </h5>

                    <br />
                </div>
            </form>
        </>
    );
}

export default ComplianceSecurity;
